module.exports = __webpack_public_path__ + "static/img/c4.02053f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/c4.png
// module id = XrMK
// module chunks = 0